import { render, staticRenderFns } from "./HerbDistributionHeatMap.vue?vue&type=template&id=21392474&scoped=true"
import script from "./HerbDistributionHeatMap.vue?vue&type=script&lang=js"
export * from "./HerbDistributionHeatMap.vue?vue&type=script&lang=js"
import style0 from "./HerbDistributionHeatMap.vue?vue&type=style&index=0&id=21392474&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21392474",
  null
  
)

export default component.exports